<mat-form-field class="w-full" [appearance]="appearance" subscriptSizing="dynamic">
  <mat-label>
    <span *ngIf="!selectedJobTypeId">{{ regionVariantService.text('general.filters.job_type.label_unselected')
      }}</span>
    <span *ngIf="selectedJobTypeId">{{ regionVariantService.text('general.filters.job_type.label_selected')
      }}</span>
  </mat-label>
  <mat-select [ngModel]="selectedJobTypeId" (selectionChange)="select($event)" [disabled]="disabled">
    <mat-option *ngFor="let jt of jobTypes" [value]="jt.adminTypeId">{{
      jt.shortDescription }}</mat-option>
  </mat-select>
  <button data-cy="clear-selected-job-type" matSuffix *ngIf="selectedJobTypeId && allowClear" mat-icon-button
    aria-label="Clear"
    (click)="clear($event)"
    [disabled]="disabled">
    <mat-icon>close</mat-icon>
  </button>
</mat-form-field>